import { render, staticRenderFns } from "./index.vue?vue&type=template&id=19c22d82&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=19c22d82&prod&lang=less&"
import style1 from "./index.vue?vue&type=style&index=1&id=19c22d82&prod&lang=less&scoped=true&"
import style2 from "./index.vue?vue&type=style&index=2&id=19c22d82&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c22d82",
  null
  
)

export default component.exports